import { useTranslation } from 'react-i18next';
import { CurrencyValue } from '../../../common/currencyValue';
import Checkbox from '../../../common/simple/Checkbox';

const MonthlyItem = ({ paymentItem, currency, onChange }) => {
    const { t } = useTranslation();

    return (
        <div className='month-item'>      
            <div className='year-and-checkbox'>
                <Checkbox
                    checked={paymentItem.isChecked}
                    onChange={() => onChange(paymentItem)}
                />
                <div>{paymentItem.payment?.year}</div>
            </div>
            <div>{t(`common.months.${paymentItem.payment?.month}`)}</div>
            <CurrencyValue notInCents={true} currency={currency}>{paymentItem.payment?.amount_left?.value}</CurrencyValue>
        </div>
    )
}

export default MonthlyItem;
